import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import googleImage from '../../../assets/images/Google Image.png';

const certificates = [
  {
    title: 'Foundations: Data, Data, Everywhere',
    issuedBy: 'Google',
    date: '20 Jan 2024',
    image: googleImage,
    link: 'https://drive.google.com/file/d/1Y8wwOC8upwEH0fuT3oMl4It7KNd-IM-e/view?usp=drive_link'
  },
  {
    title: 'Foundations of User Experience (UX) Design',
    issuedBy: 'Google',
    date: '18 Jan 2024',
    image: googleImage,
    link: 'https://drive.google.com/file/d/1v5ZKrUtZWJWf5bFJ6V7lOBBCxs_JYMkf/view?usp=drive_link'
  }
];

const GoogleCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="Google"
      certificates={certificates}
    />
  );
};

export default GoogleCertificates;
